import { Grid } from "@mui/material";
import { PublicationApprovalStatus } from "generated/CoreApi_v1";
import { ModeratorMessageButton } from "../../actions/ModeratorMessageDialog";
import { useCardContext } from "../../CardBuilder";
import { DefaultOptions } from "./DefaultOptions";
import { DeleteButton } from "./DeleteButton";
import { EditButton } from "./EditButton";
import { ThreadMasterButton } from "./ThreadItemFooter";

///
export const ModerateThreadFooter: React.FC = () => {

    const { pub: { approvalStatus, rejected, interaction: { allowEdit } } } = useCardContext();

    if (approvalStatus == PublicationApprovalStatus.Approved || approvalStatus == PublicationApprovalStatus.Canceled)
        return <></>;

    return (
        <>
            <Grid container justifyContent="space-between" alignItems="center">
                <Grid>
                    <Grid container spacing={rejected?.message != undefined ? 0 : 2} justifyContent="center" alignItems="center">
                        <Grid>
                            <ThreadMasterButton />
                        </Grid>
                        {allowEdit &&
                            <Grid>
                                <EditButton />
                            </Grid>
                        }
                        <Grid>
                            <DeleteButton />
                        </Grid>
                        {rejected?.message != undefined &&
                            <Grid>
                                <ModeratorMessageButton optionMode="rejected" />
                            </Grid>
                        }
                    </Grid>
                </Grid>
                <Grid>
                    <Grid container justifyContent="center" alignItems="center">
                        <Grid>
                            <DefaultOptions />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
};
